<template>
  <div>
    <!-- REAL DOCUMENT -->
    <div v-show="showContent">
      <div class="app-document-breadcrumbs"></div>
      <div class="app-document-sidemenu">
        <div class="app-document-menu"></div>
        <div class="app-document-sidemenu-footer"></div>
      </div>

      <div class="app-document-content">
        <vue-markdown :source="text" :html="true" />
        <div class="app-document-footer">
          <div class="app-document-footer-left">
            <a class="btn btn-light btn-sm" href="javascript:void(0)">
              <i class="fa fa-arrow-left"></i>
              ก่อนหน้า
            </a>
            <div class="app-document-previous"></div>
          </div>
          <div class="app-document-footer-right">
            <a class="btn btn-light btn-sm" href="javascript:void(0)">
              ถัดไป
              <i class="fa fa-arrow-right"></i>
            </a>
            <div class="app-document-next"></div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <GoToTop />
    </div>

    <!-- LOADING DOCUMENT -->
    <div v-if="!showContent">
      <div class="app-document-breadcrumbs">
        <ul>
          <li>
            <a class="header">
              <i class="fa fa-chevron-right" style="color: #e5e5e5 !important;"></i>
              <span
                class="app-element-loading"
                style="width: 70px; display: inline-block"
                >&nbsp;</span
              >
            </a>
          </li>
          <li>
            <a>
              <i class="fa fa-chevron-right" style="color: #e5e5e5 !important;"></i>
              <span
                class="app-element-loading"
                style="width: 100px; display: inline-block"
                >&nbsp;</span
              >
            </a>
          </li>
        </ul>
        <span style="clear: both"></span>
      </div>
      <div class="app-document-sidemenu loading">
        <div class="app-document-menu">
          <h3 class="app-element-loading" style="max-width: 200px">&nbsp;</h3>
          <ul>
            <li>
              <a
                class="app-element-loading"
                style="margin-bottom: 0.3rem; max-width: 100px"
                >&nbsp;</a
              >
            </li>
            <li>
              <a
                class="app-element-loading"
                style="margin-bottom: 0.3rem; max-width: 120px"
                >&nbsp;</a
              >
            </li>
            <li>
              <a
                class="app-element-loading"
                style="margin-bottom: 0.3rem; max-width: 120px"
                >&nbsp;</a
              >
            </li>
            <li>
              <a
                class="app-element-loading"
                style="margin-bottom: 0.3rem; max-width: 150px"
                >&nbsp;</a
              >
            </li>
            <li>
              <a
                class="app-element-loading"
                style="margin-bottom: 0.3rem; max-width: 100px"
                >&nbsp;</a
              >
            </li>
          </ul>
        </div>
        <div class="app-document-sidemenu-footer"></div>
      </div>

      <div class="app-document-content">
        <h1 class="app-element-loading" style="max-width: 300px">&nbsp;</h1>
        <p class="app-element-loading" style="max-width: 250px">&nbsp;</p>
        <blockquote class="app-element-loading">
          <p>&nbsp;</p>
        </blockquote>
        <p class="app-element-loading" style="max-width: 90%">&nbsp;</p>
        <h1 class="app-element-loading" style="max-width: 250px">&nbsp;</h1>
        <p class="app-element-loading">&nbsp;</p>
        <blockquote class="app-element-loading">
          <p>&nbsp;</p>
        </blockquote>
        <p class="app-element-loading">&nbsp;</p>
        <p class="app-element-loading" style="max-width: 80%">&nbsp;</p>

        <div class="app-document-footer">
          <div class="app-document-footer-left">
            <a class="btn btn-light btn-sm" href="javascript:void(0)">
              <i class="fa fa-arrow-left"></i>
              ก่อนหน้า
            </a>
            <div class="app-document-previous"></div>
          </div>
          <div class="app-document-footer-right">
            <a class="btn btn-light btn-sm" href="javascript:void(0)">
              ถัดไป
              <i class="fa fa-arrow-right"></i>
            </a>
            <div class="app-document-next"></div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue3-markdown-it";
import GoToTop from "@/components/GoToTop";
export default {
  components: {
    VueMarkdown,
    GoToTop,
  },
  props: {
    text: String,
  },
  data() {
    return {
      showContent: false,
      currentContext: this.$route.params.context || "overview",
      currentVersion: this.$route.params.version,
      currentDocument: this.$route.params.document,
    };
  },
  mounted() {
    this.showContentAndMenu();
  },
  watch: {
    "$route.params"() {
      const params = this.$route.params;
      const context = params.context;
      const version = params.version;
      const document = params.document;
      const sameOldParams =
        this.currentContext === context &&
        this.currentVersion === version &&
        this.currentDocument === document;

      if (!sameOldParams) {
        this.currentContext = context;
        this.currentVersion = version;
        this.currentDocument = document;

        this.showContentAndMenu();
      }
    },
  },
  methods: {
    showContentAndMenu() {
      this.showPageUpDown = false;
      const t = setInterval(() => {
        if (this.text && this.text.length) {
          clearInterval(t);
          this.showContent = true;
        }
      }, 50);
    },
  },
};
</script>

<style scoped>
.app-element-loading {
  border-radius: 5px;
}
.app-document-sidemenu.loading li {
  color: #eceff1 !important;
}
</style>